const storeName = 'payment';
export default {
    GET_PAYMENT_METHODS: `${storeName}.GET_PAYMENT_METHODS`,
    SET_PAYMENT_METHODS: `${storeName}.SET_PAYMENT_METHODS`,
    SET_IS_PAYMENT_PAGE: `${storeName}.SET_IS_PAYMENT_PAGE`,
    SET_LOADING: `${storeName}.SET_LOADING`,
    FETCH_IFRAME_URL: `${storeName}.FETCH_IFRAME_URL`,
    SET_IFRAME_URL: `${storeName}.SET_IFRAME_URL`,
    RESET_PAYMENT_PAGE_DATA: `${storeName}.RESET_PAYMENT_PAGE_DATA`,
    SET_ORDER_API_ERROR: `${storeName}.SET_ORDER_API_ERROR`,
    REMOVE_IS_PAYMENT_PAGE: `${storeName}.REMOVE_IS_PAYMENT_PAGE`,
    SET_SELECTED_CARD: `${storeName}.SET_SELECTED_CARD`,
    SET_CARD_HOLDER_NAME: `${storeName}.SET_CARD_HOLDER_NAME`,
    SET_SAVE_CARD_FLAG: `${storeName}.SET_SAVE_CARD_FLAG`,
    SET_PAY_NOW_ACTIVE: `${storeName}.SET_PAY_NOW_ACTIVE`,
    EDIT_SAVED_CARD: `${storeName}.EDIT_SAVED_CARD`,
    RESET_CARD_SELECTION: `${storeName}.RESET_CARD_SELECTION`,
    GET_SELECTED_CARD: `${storeName}.GET_SELECTED_CARD`,
    SET_PAYMENT_METHOD: `${storeName}.SET_PAYMENT_METHOD`,
    RESET_PAYMENT_METHOD: `${storeName}.RESET_PAYMENT_METHOD`,
    SET_TOKENIZATION_ALLOWED: `${storeName}.SET_TOKENIZATION_ALLOWED`,
    SET_PAYMENT_AVAILABILITY: `${storeName}.SET_PAYMENT_AVAILABILITY`,
    GET_SAVED_CARDS: `${storeName}.GET_SAVED_CARDS`,
    SET_SAVED_CARDS: `${storeName}.SET_SAVED_CARDS`,
    SET_SAVE_CARD_USED: `${storeName}.SET_SAVE_CARD_USED`,
    SET_SAVED_CARDS_AVAILABLE: `${storeName}.SET_SAVED_CARDS_AVAILABLE`,
    SET_TERMS: `${storeName}.SET_TERMS`,
    PUT_PAYMENT_MODE: `${storeName}.PUT_MODE`,
    DO_PAYMENT: `${storeName}.DO_PAYMENT`,
    TOGGLE_FIELD_VALUE: `${storeName}.TOGGLE_FIELD_VALUE`,
    GET_PAY_WITH_LOYALTY_POINTS_METHOD: `${storeName}.GET_PAY_WITH_LOYALTY_POINTS_METHOD`,
    SET_PAY_WITH_LOYALTY_POINTS_METHOD: `${storeName}.SET_PAY_WITH_LOYALTY_POINTS_METHOD`,
    PAY_WITH_LOYALTY_POINTS: `${storeName}.PAY_WITH_LOYALTY_POINTS`,
    PLACE_ORDER: `${storeName}.PLACE_ORDER`,
    SET_ERROR: `${storeName}.SET_ERROR`,
    SET_CART_NOT_FOUND: `${storeName}.SET_CART_NOT_FOUND`,
    RESET_ERRORS: `${storeName}.RESET_ERRORS`,
    SET_TERMS_ACCEPTED: `${storeName}.SET_TERMS_ACCEPTED`,
    OPEN_REMOVE_CARD_DIALOG: `${storeName}.OPEN_REMOVE_CARD_DIALOG`,
    SET_REMOVE_CARD: `${storeName}.SET_REMOVE_CARD`,
    SET_REMOVE_CARD_RESET: `${storeName}.SET_REMOVE_CARD_RESET`,
    REMOVE_SELECTED_CARD: `${storeName}.REMOVE_SELECTED_CARD`,
    FETCH_MONETAWEB_IFRAME_URL: `${storeName}.FETCH_MONETAWEB_IFRAME_URL`,
    MODIFY_DELIVERY_INFORMATION: `${storeName}.MODIFY_DELIVERY_INFORMATION`,
    GET_GIFT_CARD_METHODS: `${storeName}.GET_GIFT_CARD_METHODS`,
    SET_GIFT_CARD_METHODS: `${storeName}.SET_GIFT_CARD_METHODS`,
    PAYMENT_METHOD_SET: `${storeName}.PAYMENT_METHOD_SET`,
    RESET_SOP_DATA: `${storeName}.RESET_SOP_DATA`,
    ORDER_PLACED: `${storeName}.ORDER_PLACED`,
    SET_IS_NEW_ORDER_API_ENABLED: `${storeName}.SET_IS_NEW_ORDER_API_ENABLED`,
    UPDATE_PAYMENT_SESSION: `${storeName}.UPDATE_PAYMENT_SESSION`,
    CLEAR_PAYMENT_SESSION: `${storeName}.CLEAR_PAYMENT_SESSION`,
    SET_PAYMENT_SESSION: `${storeName}.SET_PAYMENT_SESSION`,
    SET_PAYMENT_SESSION_DELIVERY_LINE: `${storeName}.SET_PAYMENT_SESSION_DELIVERY_LINE`,
    LOAD_KLARNA_API: `${storeName}.LOAD_KLARNA_API`,
    SET_PAYMENT_SESSION_AUTHORIZED: `${storeName}.SET_PAYMENT_SESSION_AUTHORIZED`,
    SET_CARD_SAVE_SUCCESS: `${storeName}.SET_CARD_SAVE_SUCCESS`,
    PLACE_ORDER_SWIPE_TO_BUY: `${storeName}.PLACE_ORDER_SWIPE_TO_BUY`,
    RESET_REQUIRED_CHECK: `${storeName}.RESET_REQUIRED_CHECK`,
};
